import Notifications from "react-notification-system-redux";
import { updateLockoutError } from "@fpos/react-modal";
import futureaxios from "@fpos/future-axios";

import emailService from "./emailService";
import cloudService from "./cloudService";


//**************************************************************** */
//Cloud Endpoint (External)
export var cloudSvc = null;
export const initCloudSvc = (store) => {
    cloudSvc = new cloudService(function () {
        loadCloudEndPointError(store.dispatch, "error");
    });
};

export const loadCloudEndPointError = (dispatch, status) => {
    dispatch(updateLockoutError("CE", status));
};

//**************************************************************** */
//Email Endpoint
export var emailSvc = null;
export const initEmailSvc = (store) => {
    emailSvc = new emailService(function () {
        loadEmailEndPointError(store.dispatch, "error");
    });
};

export const loadEmailEndPointError = (dispatch) => {
    var notificationObj = { title: "Network Error", message: "Email not set because of a network error." };
    dispatch(Notifications.error(notificationObj));
};

//***************************************************************** */
//initialize services
export function initServices(store){
    //this applies globally to all faxios calls
    // faxios will fire error-callback before throwing
    futureaxios.options.throwOnError = false;

    initEmailSvc(store);
    initCloudSvc(store);
}